import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React, { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M112.941176,153.527059 L112.941176,1734.70353 L338.823529,1734.70353 L338.823529,944.115294 L790.588235,944.115294 L790.588235,1734.70353 L903.529412,1734.70353 L903.529412,1169.99765 L1355.29412,1169.99765 L1355.29412,1734.70353 L1468.23529,1734.70353 L1468.23529,718.232941 L1920,718.232941 L1920,1847.64471 L0,1847.64471 L0,153.527059 L112.941176,153.527059 Z M1586.59765,73 L1688.69647,121 C1681.69412,136.134118 1511.94353,491.672941 1248.33882,557.404706 C1138.56,584.623529 1030.02353,559.098824 926.117647,481.056471 C805.609412,390.703529 705.882353,364.501176 629.985882,402.449412 C496.376471,469.197647 451.764706,714.731765 451.764706,774.703529 L338.823529,774.703529 C338.823529,680.510588 395.858824,393.188235 579.501176,301.367059 C697.298824,242.637647 836.555294,272.68 993.882353,390.703529 C1070.34353,447.964706 1144.43294,466.712941 1220.78118,447.738824 C1432.43294,395.334118 1585.01647,76.1623529 1586.59765,73 Z",
  fillRule: "evenodd",
  stroke: "none",
  strokeWidth: "1"
});

var IconStatsSolid = /*#__PURE__*/function (_Component) {
  _inherits(IconStatsSolid, _Component);

  var _super = _createSuper(IconStatsSolid);

  function IconStatsSolid() {
    _classCallCheck(this, IconStatsSolid);

    return _super.apply(this, arguments);
  }

  _createClass(IconStatsSolid, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(SVGIcon, Object.assign({}, this.props, {
        name: "IconStats",
        viewBox: "0 0 1920 1920"
      }), _ref);
    }
  }]);

  IconStatsSolid.displayName = "IconStatsSolid";
  return IconStatsSolid;
}(Component);

IconStatsSolid.glyphName = 'stats';
IconStatsSolid.variant = 'Solid';
IconStatsSolid.propTypes = _objectSpread({}, SVGIcon.propTypes);
export default IconStatsSolid;
export { IconStatsSolid };